import { variables } from '@indriver/yrel';

var preset = {
  color: {
    primary: variables['text-and-icon-secondary'],
    both: 'inherit',
    secondary: 'inherit'
  },
  fontSize: '14px',
  lineHeight: '19px'
};

export { preset as default };
